module.exports = __webpack_public_path__ + "img/ring_0_0_0_0@2x.55b6ce1b.png";